import { useEffect } from 'react';
import { isBootAgent } from '../Helper';

const useTagManagerScript = (gtmId) => {
	useEffect(() => {
		if (isBootAgent()) return;
		const insertGtmScript = () => {
			const script = document.createElement('script');
			script.async = true;
			script.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${gtmId}');
      `;
			document.head.appendChild(script);
		};

		const insertGtmNoscript = () => {
			const noscript = document.createElement('noscript');
			const iframe = document.createElement('iframe');
			iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
			iframe.height = '0';
			iframe.width = '0';
			iframe.style.display = 'none';
			iframe.style.visibility = 'hidden';
			iframe.id = 'tag-manager';
			noscript.appendChild(iframe);
			document.body.appendChild(noscript);
		};
		insertGtmScript();
		insertGtmNoscript();

		return () => {
			const script = document.querySelector('#google-tag-manager-script');
			const noscript = document.querySelector('#google-tag-manager-noscript');
			if (script && script.parentNode) script.parentNode.removeChild(script);
			if (noscript && noscript.parentNode) noscript.parentNode.removeChild(noscript);
		};
	}, [gtmId]);
};

export default useTagManagerScript;
